export default __webpack_public_path__ + "static/columnPinning-0a2220be879b9ad3f43762fe6e8f50c5.gif";